<template>
  <div class="season-select !min-h-0" :tabindex="tabindex" @focusout="handleBlur" :class="classes, opened ? 'z-modal' : ''">
    <div class="selected zt-hover font-medium transition-opacity min-w-[170px]"
         :class="{ open: opened && window.size.desktop, '!text-center' : center, 'opacity-40': textShown === placeholder }"
         @click="openOptions" ref="list"
         v-text="getSeasonPhaseString(textShown, true).replace(' -  ', '')"></div>
    <div v-if="window.size.desktop" class='items !min' :class="{'selectHide': !opened}" :style="optionsDivStyles">
      <div class="h-[40px] !pl-0 pt-2.5 text-center" v-for="option of optionsToShow" @click="selectOption(option)"
      :class="{'!bg-zt-light' : model.string === option}">
        {{ getSeasonPhaseString(option, true).replace(' - ', '') }}
      </div>
      <div v-if="showNoResultsInfo && !optionsToShow.length">
        Brak wyników
      </div>
    </div>
	  <div v-if="window.size.mobile && opened">
		  <SeasonPhaseSelectMobile @close-modal="() => this.opened = false" @change-option="selectOption"
		                           :model="model" :options="optionsToShow" />
	  </div>
  </div>
	<div v-if="opened" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"></div>
</template>

<script>
import football_mixin from "../mixins/football_mixin";
import utils_mixin from "../mixins/utils_mixin";
import SeasonPhaseSelectMobile from "./SeasonPhaseSelectMobile.vue";
export default {
  name: 'SeasonPhaseSelect',
	components: {SeasonPhaseSelectMobile},
  mixins: [football_mixin, utils_mixin],
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      default: null,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    center: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    resetOnClick: {
      type: Boolean,
      default: true,
    },
    showNoResultsInfo: {
      type: Boolean,
      default: false,
    },
	  classes: {
			type: String,
	  },
    model: {
      type: Object,
      required: false,
      default(rawProps) {
        if (!rawProps.placeholder) {
          return { string: rawProps.default ?? rawProps.options[0] }
        } else {
          return { string: rawProps.default ?? '' }
        }
      }
    },
    optionsDivStyles: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    optionsToShow() {
      if (this.model.string === '') {
        return this.options;
      } else if (this.default && this.model.string === this.default) {
        return this.options;
      } else if (this.options.length > 0 && this.model.string === this.options[0]) {
        return this.options;
      }  else {
        return this.options;
      }
    },
    textShown() {
      if (this.placeholder) {
        return this.model.string === '' ? this.placeholder : this.model.string;
      } else {
        return this.model.string;
      }
    }
  },
  mounted() {
    this.$emit('input', this.model.string);
    if (this.default) {
      this.model.string = this.default;
    }
  },
  methods: {
    openOptions() {
      if (this.opened) {
        this.opened = false;
				this.unblockScrolling();
        return;
      }
      if (!this.disabled) {
        this.opened = true;
				if (window.size.desktop) {
					let extraOff = WP.user.adminBar ? -32 : 0;
					const y = this.$refs.list.getBoundingClientRect().top + window.pageYOffset + extraOff - 150;
					this.blockScrolling();
					window.scrollTo({top: y, behavior: 'smooth'});
				} else {
					this.blockScrolling();
				}
        if ( this.opened && this.editable && (this.resetOnClick || this.model.string === this.default) ) {
          this.model.string = '';
        }
      }
    },
    selectOption(option) {
      this.model.string = option;
      this.opened = false;
			this.unblockScrolling();
      this.$emit('input', option);
    },
    handleBlur(e) {
      if (e.relatedTarget === this.$el) {
        return;
      }
      this.opened = false;
	    this.unblockScrolling();
      if (this.model.string === '') {
        this.model.string = this.default ? this.default : '';
      }
    }
  },
};
</script>

<style scoped>
.season-select {
  @apply px-0 !important;
  @apply leading-[18px] outline-none relative text-left h-[28px];
}

.season-select .selected {
  @apply h-[28px] pl-4 pr-8 pt-1 cursor-pointer select-none truncate;
}

.season-select .selected.open {
  @apply border-zt-light rounded-t-zt;
}

.season-select .selected:after {
  @apply absolute top-3 right-4 w-0 h-0;
  content: "";
  border: 5px solid transparent;
  border-color: #fff transparent transparent transparent;
}

.season-select .items {
  @apply absolute left-0 right-0 z-10 border-x border-b border-zt-light rounded-b-zt bg-[#283344] max-h-[300px] overflow-y-auto;
}

.season-select .items div {
  @apply text-text pl-4 cursor-pointer select-none border-b border-zt-light last:border-0;
}

.season-select .items div:hover {
  @apply bg-zt-light/35;
}

.selectHide {
  @apply hidden;
}
</style>